// Studio's Toast is now the shared @archlang/ui kit. This shim wraps the kit's
// ToastProvider to inject Studio's translated close-button label (the kit is
// i18n-agnostic by design), and re-exports the rest unchanged so the existing
// `../ui/Toast` import sites keep working. Edit the canonical component in
// packages/ui, not here.
import { type ReactNode } from "react";
import { ToastProvider as BaseToastProvider } from "@archlang/ui";
import { useTranslation } from "../i18n";

export { useToast } from "@archlang/ui";
export type { ToastKind, ToastOptions } from "@archlang/ui";

export function ToastProvider({ children }: { readonly children: ReactNode }) {
  const { t } = useTranslation("app");
  return (
    <BaseToastProvider dismissLabel={t("toast.dismiss")}>
      {children}
    </BaseToastProvider>
  );
}
